module.exports = __webpack_public_path__ + "6023c5dd9229ca02bbf66b54048be3ff.mp3";